var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"short_chip"},[(_vm.value)?_c('v-chip',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.value))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }